const WHAT: Record<string, string> = {
  model_flips: 'model-flip alerts',
  line_moves: 'line-movement emails',
  weekly_recap: 'the weekly recap',
  lineup_alerts: 'lineup alert emails',
  all: 'all Delta Picks emails',
};

/**
 * Where the unsubscribe link in every email lands. Public: it has to work
 * from any inbox without signing in. The change is already saved by then.
 */
export default function Unsubscribed() {
  const q = new URLSearchParams(window.location.search);
  const invalid = q.has('invalid');
  const what = WHAT[q.get('c') ?? 'all'] ?? WHAT.all;
  return (
    <div className="privacy">
      <a href="/" className="logo" style={{ marginBottom: 24 }}>
        <span className="logo-mark" aria-hidden>Δ</span>
        DeltaPicks
      </a>
      <h1 className="page-title">{invalid ? 'That link has expired' : 'You’re unsubscribed'}</h1>
      <div className="prose">
        {invalid ? (
          <p>We couldn&rsquo;t match that link to an account. Sign in and turn emails off on the Alerts page instead.</p>
        ) : (
          <p>You won&rsquo;t get {what} any more. It can take a few minutes for an email already on its way to stop.</p>
        )}
        <p>
          <a href="/account/alerts">Manage alerts</a> to change this, or turn other emails on or off.
        </p>
      </div>
    </div>
  );
}
